import React from 'react';
import { FC, PropsWithChildren } from 'react';
import SelectBoxStyles from '../InputField/InputField.module.css';

//  removed disabled={disable} from select due to this text inside the selectbox was not visible

type SelectBoxProps = PropsWithChildren<{
  name?: string;
  icon?: string;
  value: string;
  locked?: boolean;
  errorMessage?: string;
  label?: string;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  inputContainerStyle?: React.CSSProperties;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  labelStyle?: React.CSSProperties;
  placeholder?:string
  customClass?:string,
  className?:string
  containerClass?:string
  labelClass?:string,
  errorClass?:string
  disable?:boolean

}>;

const SelectInputBox: FC<SelectBoxProps> = ({
  children,
  name,
  label,
  icon,
  value,
  onChange,
  locked,
  errorMessage,
  style,
  containerStyle,
  inputContainerStyle,
  labelStyle,
  placeholder,
  customClass,
  className,
  containerClass,
  labelClass,
  errorClass,
  disable,

  
}) => {
  const disabledClass = disable ? SelectBoxStyles.disabled : '';
  return (
    <div className={`${SelectBoxStyles.form_input} ${className || ''} ${disabledClass}`} style={containerStyle}>
      {label && (
        <label htmlFor={name} className={`${SelectBoxStyles.form_input__label} ${labelClass || ''}`}style={labelStyle}>
          {label}
        </label>
      )}
      <div className={`${SelectBoxStyles.form_input__container} ${containerClass|| ''}`}  style={inputContainerStyle}>
        {!locked ? (
          <>
            {icon && (
              <svg className={SelectBoxStyles.form_input__icon}>
                <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
              </svg>
            )}
           
            <select value={value} name={name} id={name} className={`${SelectBoxStyles.form_input__box} ${customClass || ''}`} onChange={onChange} style={style}  >
              {children}
            </select>
          </>
        ) : (
          <>
            <p
              className={SelectBoxStyles.form_input__box}
              style={{ height: '1.5rem', lineHeight: '1', color: value ? 'var(--grey)' : 'var(--light-grey)' }}
            >
              {value || label}
            </p>
            <svg className={SelectBoxStyles.form_input__icon}>
              <use xlinkHref={`/assets/sprite.svg#icon-lock`} />
            </svg>
          </>
        )}
      </div>
      {errorMessage && <p className={`${SelectBoxStyles.form_input__error} ${errorClass || ''}`}>{errorMessage}</p>}
    </div>
  );
};

export default SelectInputBox;
